/* eslint-disable */
import {  Space, message, Card, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import api from "@/utils/api";
import http from "@/utils/http";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
// import AddModal from "./component/addModal";
import "./component/index.scss"
import InsuranceVPH from "./component/InsuranceVPH"; 

const INIT_TABLE_HEAD = {
  propName: null,
  propType: null,
};

export default function InsuranceProp() {
  const addModalRef = useRef(null);

  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [propTypeOptions, setPropTypeOptions] = useState([]);
  const [tableHead, setTableHead] = useState(INIT_TABLE_HEAD);
  const [selectedProp, setSelectedProp] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // 保存最新的筛选条件 / 每页条数，供异步函数读取，避免闭包拿到旧值
  const tableHeadRef = useRef(INIT_TABLE_HEAD);
  const pageSizeRef = useRef(25);
  useEffect(() => {
    tableHeadRef.current = tableHead;
  }, [tableHead]);
  useEffect(() => {
    pageSizeRef.current = pagination.pageSize;
  }, [pagination.pageSize]);

  // ============ 列表 ============
  const getTableListFn = async (
    current = 1,
    pageSize = pageSizeRef.current,
    head = tableHeadRef.current,
  ) => {
    setTableLoading(true);
    const params = { page: current, count: pageSize, ...head };
    try {
      const response = await http.get(api.getInsuranceByPropShow, { params });
      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        return;
      }
      const list = (response.data.list || []).map((item, index) => ({
        ...item,
        "#": (params.page - 1) * params.count + index + 1,
      }));
      setTableList(list);
      setPagination((prev) => ({
        ...prev,
        total: response.data.total || 0,
        current: params.page,
        pageSize: params.count,
      }));
    } catch (error) {
      console.error("Failed to fetch data:", error);
      message.error("Failed to load data, please try again later");
    } finally {
      setTableLoading(false);
    }
  };

  // ============ 下拉数据 ============
  const getPropTypeData = async () => {
    try {
      const response = await http.get(api.getPropTypeList);
      const data = Array.isArray(response) ? response : response?.data;
      setPropTypeOptions(
        (Array.isArray(data) ? data : []).map((item) => ({
          label: item?.name,
          value: item?.code,
        })),
      );
    } catch (error) {
      console.error("Failed to fetch property types:", error);
    }
  };

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
      pageSize: pageSizeRef.current,
    });
  };

  // ============ 列============
  const initColumns = [
{
  title: "Property",
  dataIndex: "propName",
  key: "propName",
  width: 180,
  titleType: "Input",
  onChange: (e) => tableFilterFn(e, "propName"),
  render: (text, record) => (
    <span
      style={{ cursor: "pointer", color: "#2563EB" }}
      onClick={() => setSelectedProp(record)}
    >
      {text || ""}
    </span>
  ),
},
    {
      title: "Type",
      dataIndex: "propType",
      key: "propType",
      titleType: "Select",
      selectOptions: propTypeOptions,
      width: 100,
      onChange: (e) => tableFilterFn(e, "propType", "Select"),
    },
    {
      title: "Units",
      dataIndex: "units",
      key: "units",
      titleType: "Input",
      width: 80,
       onChange: (e) => tableFilterFn(e, "units", ),
    },
  ];

  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 下拉数据回来后刷新列
  useEffect(() => {
    setColumns(commonFn.handleColunmFn(initColumns));
  }, [propTypeOptions]);

  // 首次加载
  useEffect(() => {
    getTableListFn(1, 25, INIT_TABLE_HEAD);
    getPropTypeData();
  }, []);

  // 点击顶部刷新：清空筛选，回第一页
  useEffect(() => {
    if (!refreshKey) return;
    setTableHead(INIT_TABLE_HEAD);
    tableHeadRef.current = INIT_TABLE_HEAD;
    getTableListFn(1, pageSizeRef.current, INIT_TABLE_HEAD);
  }, [refreshKey]);

  const handleTableChange = (p) => {
    getTableListFn(p.current, p.pageSize, tableHeadRef.current);
  };

 return (
  <main className="insurance-prop-page financial-dashboard">
    <section className="insurance-prop-layout">
      {/* 左：表格 */}
      <Card className="insurance-prop-left-card" title="Properties">
        <CustomTableExtend
          columns={columns}
          setColumns={setColumns}
          initColumns={initColumns}
          refreshKey={refreshKey}
          setRefreshKey={setRefreshKey}
          noShowList={[!commonFn.btnAuthorityFlag("Download") && "download"]}
        >
          <div className="topLeft">
          </div>
        </CustomTableExtend>

        <div className="insurance-prop-table-host">
          <CustomTable
            key={refreshKey}
            refreshKey={refreshKey}
            tableLoading={tableLoading}
            columns={columns}
            tableList={tableList}
            handleTableChange={handleTableChange}
            rowKey="id"
            pagination={pagination}
            tableCss="maintenanceTable insurance-prop-table"
               tableScroll={{ x: "max-content", y: "calc(100vh - 450px)" }}
              rowClassName={(r) =>
             r.propId === selectedProp?.propId ? "insurance-prop-row-active" : ""
            }
          />
        </div>
      </Card>

      {/* 右*/}
  <Card className="insurance-prop-right-card" title="Payment History">
  <InsuranceVPH record={selectedProp} />
</Card>
    </section>
  </main>
);
}